import React, { useState } from 'react';
import axios from 'axios';

const NotesCard = ({ notes, setNotes, user, API_BASE }) => {
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [noteInput, setNoteInput] = useState('');
  const [selectedNote, setSelectedNote] = useState(null);

  // Get recent notes (top 3)
  const recentNotes = notes.slice(0, 3);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    if (isToday) {
      return 'Today ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  const handleSaveNote = async () => {
    if (!noteInput.trim()) {
      alert('Note content is required');
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE}/calendar/notes`,
        { content: noteInput },
        { withCredentials: true }
      );
      setNotes([response.data, ...notes]);
      setNoteInput('');
      setShowNoteModal(false);
    } catch (error) {
      console.error('Error saving note:', error);
      alert('Failed to save note');
    }
  };

  const handleDeleteNote = async (noteId) => {
    if (!window.confirm('Are you sure you want to delete this note?')) return;

    try {
      await axios.delete(`${API_BASE}/calendar/notes/${noteId}`, { withCredentials: true });
      setNotes(notes.filter(note => note.id !== noteId));
      setSelectedNote(null);
    } catch (error) {
      console.error('Error deleting note:', error);
      alert('Failed to delete note');
    }
  };

  return (
    <div className="desk-card notes-card">
      <div className="desk-card-header">
        <div className="desk-card-header-left">
          <div className="desk-card-icon notes">
            <span>&#128221;</span>
          </div>
          <span className="desk-card-title">Shared Notes</span>
        </div>
        <button className="desk-card-action" onClick={() => setShowNoteModal(true)}>
          + Add Note
        </button>
      </div>
      <div className="desk-card-body">
        {recentNotes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '1rem', color: '#a0aec0', fontSize: '0.85rem' }}>
            No notes yet
          </div>
        ) : (
          recentNotes.map(note => (
            <div
              key={note.id}
              className="note-item"
              onClick={() => setSelectedNote(note)}
              style={{ cursor: 'pointer' }}
            >
              <div className="note-preview">{note.content}</div>
              <div className="note-meta">
                {note.created_by_name} • {formatTime(note.created_at)}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Create Note Modal */}
      {showNoteModal && (
        <div className="modal-overlay" onClick={() => setShowNoteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Create New Note</h3>
              <button className="modal-close" onClick={() => setShowNoteModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Note Content</label>
                <textarea
                  value={noteInput}
                  onChange={(e) => setNoteInput(e.target.value)}
                  placeholder="Write your note here... (visible to all admins)"
                  rows="6"
                  style={{ width: '100%', resize: 'vertical' }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowNoteModal(false)}>Cancel</button>
              <button className="btn-create" onClick={handleSaveNote}>Save Note</button>
            </div>
          </div>
        </div>
      )}

      {/* View Note Modal */}
      {selectedNote && (
        <div className="modal-overlay" onClick={() => setSelectedNote(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Note Details</h3>
              <button className="modal-close" onClick={() => setSelectedNote(null)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{
                background: '#fffdf7',
                borderLeft: '3px solid #ecc94b',
                padding: '1rem',
                borderRadius: '0 8px 8px 0',
                marginBottom: '1rem'
              }}>
                <p style={{ whiteSpace: 'pre-wrap', color: '#2d3748' }}>{selectedNote.content}</p>
              </div>
              <div style={{ fontSize: '0.8rem', color: '#718096' }}>
                Created by <strong>{selectedNote.created_by_name}</strong> on {new Date(selectedNote.created_at).toLocaleString()}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-cancel"
                style={{ background: '#fed7d7', color: '#c53030', border: 'none' }}
                onClick={() => handleDeleteNote(selectedNote.id)}
              >
                Delete
              </button>
              <button className="btn-create" onClick={() => setSelectedNote(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotesCard;
